import React from 'react';
import { Link as RouterLink} from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Grid, Container, Typography, Box } from '@mui/material';
import { Add, Unauthorized } from '../sections/@dashboard/manageUser';
import { getAdmin } from '../services/LocalStorageService';

export default function UserAdd() {

  return (
    <>
      <Helmet>
        <title> DV Agent </title>
      </Helmet>
      <Container maxWidth="xxl">
        <Grid item xs={12}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Box to="/cloud/users" component={RouterLink} state={{ dropdownState: 'Users' }}>
              <img width={40} src="../../assets/back-button.gif" alt="verified" style={{ marginLeft: 4, display: 'inline-block', verticalAlign: 'middle' }} />
            </Box>
            <Typography
              gutterBottom
              variant=""
              component="div"
              sx={{
                color: '#A8A196',
                textAlign: 'left',
                marginLeft: 2,
                fontSize: '1.2rem',
                fontWeight: 'bold',
              }}
            >
              I AM
              <Typography variant="" component="div" sx={{ fontSize: 12, color: '#4D4D4D' }}>
                ADD USER
              </Typography>
            </Typography>
          </div>
        </Grid>
        <Grid container spacing={2} mt={1}>
          {getAdmin() === 'false' ? <Unauthorized/> :<Add/>}
        </Grid>
      </Container>
    </>
  );
}